export default "__VITE_ASSET__D9vhjQ_5__"